// Page-view tracking that works with Turbo Drive (no full page loads).
// GA4:      enabled when the gtag snippet is present (GOOGLE_ANALYTICS_ID env).
// Mixpanel: enabled when <meta name="mixpanel-token"> is present (MIXPANEL_TOKEN env).
import mixpanel from "mixpanel-browser"

const mixpanelToken = document.querySelector('meta[name="mixpanel-token"]')?.content
let mixpanelReady = false

if (mixpanelToken) {
  mixpanel.init(mixpanelToken, {
    api_host: "https://api-eu.mixpanel.com", // EU data residency — drop if your project is US
    track_pageview: false,
    persistence: "localStorage"
  })
  mixpanelReady = true
}

function trackPageView() {
  const page = { page_path: location.pathname + location.search, page_title: document.title }

  if (typeof window.gtag === "function") {
    window.gtag("event", "page_view", page)
  }
  if (mixpanelReady) {
    mixpanel.track_pageview({ page_title: document.title })
  }
}

// Fires on initial load and every Turbo visit
document.addEventListener("turbo:load", trackPageView)

// Small helper for custom events from anywhere: window.track("newsletter_signup", { plan: "free" })
window.track = (name, props = {}) => {
  if (typeof window.gtag === "function") window.gtag("event", name, props)
  if (mixpanelReady) mixpanel.track(name, props)
}
